import { crudSelectorsCustom } from 'redux/crudCreatorCustom/selector';
import { MODEL_NAME } from './actions';

export const companiesOfMeBasicSelectors = crudSelectorsCustom(MODEL_NAME);
